module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/drag-0e2c4cd6adb7c693aa30b8ca2e16ce26.svg";